import {
  EditSection as SharedEditSection,
  type EditSectionProps,
} from '../../../shared/EditSection';

import { LockedPill } from './LockedPill';

export type { EditSectionProps };

/** The shared edit section, marked "Locked" for viewers who cannot edit this venue. */
export function EditSection(props: EditSectionProps) {
  const action = (
    <>
      {props.action}
      {props.readOnly && <LockedPill />}
    </>
  );
  return <SharedEditSection {...props} action={action} />;
}
